module.exports = __webpack_public_path__ + "static/media/pencil.b06db8b1.svg";